import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class VShareNetwork extends Vue {
  @Prop() description!: string;
  @Prop() url!: string;
  @Prop() network!: keyof typeof VShareNetwork.networks;

  private static networks = {
    whatsapp: "https://api.whatsapp.com/send?text=@t%0D%0A@u",
    facebook:
      "https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h",
  };

  get generatedUrl() {
    const url = encodeURIComponent(this.url);
    const description = encodeURIComponent(this.description);

    if (
      this.network &&
      Object.keys(VShareNetwork.networks).includes(this.network)
    ) {
      return VShareNetwork.networks[this.network]
        .replace("@t", description)
        .replace("@u", url);
    } else {
      return VShareNetwork.networks.whatsapp
        .replace("@t", description)
        .replace("@u", url);
    }
  }

  replaceData(url: string, description: string) {}
}
